import React, { useEffect, useState } from 'react';
import "./Category.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import {Icon} from 'react-icons-kit';
import {menu} from 'react-icons-kit/feather/menu';
import {arrowUp} from 'react-icons-kit/feather/arrowUp';
import {trash} from 'react-icons-kit/feather/trash';
import {eye} from 'react-icons-kit/feather/eye';
import {arrowUpRight} from 'react-icons-kit/feather/arrowUpRight';
import {useNavigate} from 'react-router-dom'; 
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import {useJwt} from "react-jwt";

function CustomerHomePage(){
    return (<h1>Welcome to Customer Home Page!!</h1>);
};
export default CustomerHomePage;
